
type ResponseJWT = {
  exp: number
  filial: number
  iat: number,
  roles: {authority: string}[]
  sub: string
}

export function parseJwt(token: string): ResponseJWT | undefined  {
  try {
    var base64Url = token?.split('.')[1];
    if (!base64Url) return undefined;

    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch {
    return undefined;
  }
}
